import PropTypes from "prop-types";
import { t } from "../../../../../services";
import { FlexContainers, GradientLoader, Paragraph2 } from "../../../../../components";
import { StatsInfoContainer } from "./styled";

export const StatsInfo = ({ title, stats, loading }) => {
  return (
    <StatsInfoContainer Container={FlexContainers.FlexRowBetween} width={"100%"} gap={8}>
      <Paragraph2>{t(title)}</Paragraph2>
      {loading ? <GradientLoader width={115} height={21} /> : <span>{stats}</span>}
    </StatsInfoContainer>
  );
};

StatsInfo.propTypes = {
  title: PropTypes.string.isRequired,
  stats: PropTypes.number,
  loading: PropTypes.bool
};
